
export default {
  name: "NoticeIndex"
}
